import { TippyDefault } from 'app/components/Tippy';

import { TimeframeExport } from 'app/modules/reporting/components/TimeframeExport';
import { downloadHeartbeat } from 'app/modules/system-settings/devices/core/requests';

import { useBoolean } from 'app/hooks';

const ExportHeartbeat = ({
  code,
  onCloseMenu,
  is10Hz,
}: {
  code: string;
  onCloseMenu?: () => void;
  is10Hz?: boolean;
}) => {
  const isOpen = useBoolean(false);
  const isLoading = useBoolean(false);

  const handleClose = () => isOpen.setValue(false);
  const handleOpen = () => isOpen.setValue(true);

  const handleExport = async (filter: { fromDate: Date; toDate: Date }) => {
    try {
      isLoading.setValue(true);

      const { fromDate, toDate } = filter;

      const from = new Date(
        Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()),
      );
      const to = new Date(
        Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999),
      );

      await downloadHeartbeat({
        binId: code,
        from: from.getTime().toString(),
        to: to.getTime().toString(),
        extraWith10Hz: is10Hz ? 'true' : undefined,
      });
    } finally {
      isLoading.setValue(false);
      isOpen.setValue(false);
      onCloseMenu?.();
    }
  };
  return (
    <>
      <span onClick={handleOpen}>{is10Hz ? 'Export Heartbeat + 10Hz' : 'Export Heartbeat'}</span>
      <TippyDefault
        containerClass="action-menu"
        placement="bottom-start"
        offset={[0, 10]}
        interactive
        arrow={false}
        trigger="click"
        visible={isOpen.value}
        onClickOutside={handleClose}
        allowHTML
        content={
          isOpen.value && (
            <TimeframeExport
              onExport={handleExport}
              onClose={handleClose}
              isSubmitting={isLoading.value}
              title="Export Heartbeat"
              maxMonths={3}
            />
          )
        }
      >
        <span className="hidden"></span>
      </TippyDefault>
    </>
  );
};

export default ExportHeartbeat;
